import { useState, type ReactNode } from "react";
import { FounderActionIcon } from "./FounderActionIcons";

type FounderConfirmPublishProps = {
  message: string;
  onConfirm: (confirmPassword?: string) => void;
  onCancel: () => void;
  submitting?: boolean;
  children?: ReactNode;
  requirePassword?: boolean;
};

export function FounderConfirmPublish({
  message,
  onConfirm,
  onCancel,
  submitting = false,
  children,
  requirePassword = false,
}: FounderConfirmPublishProps) {
  const [confirmPassword, setConfirmPassword] = useState("");

  return (
    <div className="oac-founder-confirm">
      <p>{message}</p>
      {children}
      {requirePassword ? (
        <div className="oac-founder-field">
          <label htmlFor="founder-confirm-password-action">Current password</label>
          <input
            autoComplete="current-password"
            id="founder-confirm-password-action"
            onChange={(e) => setConfirmPassword(e.target.value)}
            type="password"
            value={confirmPassword}
          />
        </div>
      ) : null}
      <div className="oac-founder-actions">
        <button
          aria-label={submitting ? "Publishing update" : "Publish update"}
          className="oac-founder-icon-btn oac-founder-icon-btn--publish"
          disabled={submitting || (requirePassword && !confirmPassword.trim())}
          onClick={() => onConfirm(requirePassword ? confirmPassword : undefined)}
          title={submitting ? "Publishing..." : "Publish update"}
          type="button"
        >
          <FounderActionIcon className="oac-founder-icon-btn__icon" kind="publish" />
        </button>
        <button
          aria-label="Cancel"
          className="oac-founder-icon-btn"
          disabled={submitting}
          onClick={onCancel}
          title="Cancel"
          type="button"
        >
          <FounderActionIcon className="oac-founder-icon-btn__icon" kind="cancel" />
        </button>
      </div>
    </div>
  );
}
